module.exports = __webpack_public_path__ + "media/watersplash.9c74d7e2.mov";